import { render, staticRenderFns } from "./AddPromo.vue?vue&type=template&id=5331604e&scoped=true&"
import script from "./AddPromo.vue?vue&type=script&lang=js&"
export * from "./AddPromo.vue?vue&type=script&lang=js&"
import style0 from "./AddPromo.vue?vue&type=style&index=0&id=5331604e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331604e",
  null
  
)

export default component.exports